import React from 'react';
import StyledCheckbox from '@components/checkbox/styled.tsx';
import type { CheckboxProps } from 'antd';

export interface BaseCheckboxProps extends CheckboxProps {
    isSmallSize?: boolean;
    isReadOnly?: boolean;
    hasError?: boolean;
}

const getClassName = (hasError: boolean, isReadOnly: boolean) => {
    if (hasError) return 'has-error';
    if (isReadOnly) return 'read-only';

    return '';
};

export const BaseCheckbox: React.FC<BaseCheckboxProps> = ({
    hasError = false,
    isSmallSize = false,
    isReadOnly = false,
    ...props
}) => (
    <StyledCheckbox
        className={getClassName(hasError, isReadOnly)}
        {...props}
        $isSmallSize={isSmallSize}
        $hasError={hasError}
        $isReadOnly={isReadOnly}
    />
);
